/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const jOMInventoryImportDataSchema = z.object({
	organisationId: z.string().uuid(),
	catalogueItemType: z.string(),
	valueCents: z.number(),
	quantity: z.number(),
	description: z.string(),
	expiresAt: z.iso.datetime(),
	externalReference: z.string().nullable().optional(),
})

export type JOMInventoryImportDataSchema = z.infer<typeof jOMInventoryImportDataSchema>
